import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Street } from './street.model';

export const StreetActions = createActionGroup({
  source: 'Street/API',
  events: {
    'Load Streets': props<{ streets: Street[] }>(),
    'Add Street': props<{ street: Street }>(),
    'Upsert Street': props<{ street: Street }>(),
    'Add Streets': props<{ streets: Street[] }>(),
    'Upsert Streets': props<{ streets: Street[] }>(),
    'Update Street': props<{ street: Update<Street> }>(),
    'Update Streets': props<{ streets: Update<Street>[] }>(),
    'Delete Street': props<{ id: string }>(),
    'Delete Streets': props<{ ids: string[] }>(),
    'Clear Streets': emptyProps(),

    // Effect actions
    'Get All Streets By Ward':props<{ wardUniqueId: string }>(),
    'Streets Loading State': props<{ loading: boolean }>(),
  }
});
